import { ProcessingFeeResponse, PaymentMethodType, OrderPaymentType } from '../../types';
import { eventsRequest } from '../../utils/eventsRequest';

const applyProcessingFeeToOrder = async (
	orderUUID: string,
	paymentTypeCode: number,
	orderPaymentType: OrderPaymentType,
) : Promise<ProcessingFeeResponse | false> => {
	try {
		const paymentMethod = PaymentMethodType[paymentTypeCode];
		const response = await eventsRequest(`/orders/${orderUUID}/payment/fees`, 'post', {
			paymentMethod,
			orderPaymentType,
		});

		if (response.status === 201) {
			return response.data as ProcessingFeeResponse;
		} else {
			return false;
		}
	} catch (error) {
		console.error(error);
		return false;
	}
}

export default applyProcessingFeeToOrder;